import React, { useState } from 'react';
import Header from './includes/header';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/home';
import Footer from './includes/footer';
import Courses from './components/courses';
import Course from './components/course';
import Register from './components/register';
import Contact from './components/contact';
import Payment from './components/payment';
import ConfirmPay from './components/confirmpay';
import AIAgent from './components/AIAgent';
// import InstallPrompt from './components/InstallPrompt';
import './assets/vendors/bootstrap/bootstrap.css';
import './assets/vendors/awesome/css/fontawesome-all.min.css';
import './assets/vendors/flaticon/flaticon.css';
import './assets/vendors/magnific-popup/magnific-popup.css';
import './assets/vendors/animate-css/animate.css';
import './assets/vendors/animated-headline/animated-headline.css';
import './assets/vendors/owl/assets/owl.carousel.min.css';
import './assets/vendors/owl/assets/owl.theme.default.min.css';
import './assets/css/woocomerce.css';
import './assets/css/style.css';
import './assets/css/responsive.css';
import './assets/js/script.js';
import './components/AIAgent.css';
import ScrollToTop from './components/ScrollToTop';

function App() {
    const [showAIAgent, setShowAIAgent] = useState(() => {
        const hasShown = sessionStorage.getItem("aiAgentShown");
        if (!hasShown && (window.location.pathname === "/" || window.location.pathname === "/home")) {
            sessionStorage.setItem("aiAgentShown", "true");
            return true;
        }
        return false;
    });

    return (
        <Router>
            <ScrollToTop />
            {/* <InstallPrompt /> */}
            <div className="ai-agent-trigger">
                <button onClick={() => setShowAIAgent(true)} className="ai-agent-btn">
                    <i className="fas fa-robot"></i> Find Your Course
                </button>
            </div>
            {showAIAgent && <AIAgent onClose={() => setShowAIAgent(false)} />}
            <Routes>
                <Route path='/' element={<><Header /><Home /><Footer /></>} />
                <Route path='/home' element={<><Header /><Home /><Footer /></>} />
                <Route path='/courses' element={<><Header /><Courses /><Footer /></>} />
                <Route path='/*' element={<div>Not Found</div>} />
                <Route path='/register' element={<><Header /><Register /><Footer /></>} />
                <Route path='/courses/:courseSlug' element={<><Header /><Course /><Footer /></>} />
                <Route path='/contact' element={<><Header /><Contact /><Footer /></>} />
                <Route path='/pay' element={<Payment />} />
                <Route path='/confirm' element={<ConfirmPay />} />
            </Routes>
        </Router>
                                    );
                                }

                                export default App;